type Attributes = Record<string, number | string>;

export interface TrendEntry {
  lastupdatedon: number;
  originalValues: Attributes;
  previousValues?: Attributes;
  [key: string]: unknown;
}

interface FeatureData {
  features: { attributes: Attributes }[];
}

export function calculateTrends(data: FeatureData): TrendEntry[] {
  if (data.features.length === 0) return [];
  const features = [...data.features];

  // Sort features by 'lastupdatedon' in ascending order
  features.sort(
    (a, b) => (a.attributes.lastupdatedon as number) - (b.attributes.lastupdatedon as number)
  );

  const trends: TrendEntry[] = [
    {
      ...features[0].attributes,
      lastupdatedon: features[0].attributes.lastupdatedon as number,
      originalValues: features[0].attributes,
    },
  ];

  for (let i = 1; i < features.length; i++) {
    const trend: Record<string, unknown> = {};
    for (const attribute in features[i].attributes) {
      if (attribute !== 'lastupdatedon' && attribute !== 'comments') {
        trend[attribute] =
          (features[i].attributes[attribute] as number) -
          (features[i - 1].attributes[attribute] as number);
      }
    }
    trend['lastupdatedon'] = features[i].attributes.lastupdatedon;
    trend['originalValues'] = features[i].attributes;
    trend['previousValues'] = features[i - 1].attributes;
    trends.push(trend as TrendEntry);
  }

  return trends;
}
